// src/stores/player-types.ts
export interface PlayerAsset {
  /** Stable id (file id). */
  id: string;
  /** Direct URL; replaced lazily by the store's resolveSource (signed URLs). */
  src: string;
  /**
   * Explicit MIME type. REQUIRED for presigned URLs: without it Shaka does a
   * HEAD request, which a GET-signed URL rejects with 403.
   */
  mimeType?: string;
  title: string;
  /** Speaker / collection / site — shown as artist in the notification. */
  artist?: string;
  /** Cover image. When missing, Limeplay's fallback-poster is used. */
  poster?: string;
  kind: "audio" | "video";
  /** SSR detail page of this media (for deep links / analytics). */
  href?: string;
}

export interface AssetLoadContextLike {
  asset: { id?: string; src?: string };
  signal: AbortSignal;
}

const MIME_BY_EXT: Record<string, string> = {
  mp3: "audio/mpeg",
  m4a: "audio/mp4",
  aac: "audio/aac",
  ogg: "audio/ogg",
  oga: "audio/ogg",
  opus: "audio/ogg",
  wav: "audio/wav",
  flac: "audio/flac",
  weba: "audio/webm",
  mp4: "video/mp4",
  webm: "video/webm",
  m3u8: "application/x-mpegurl",
  mpd: "application/dash+xml",
};

/** Guess a MIME type from a file name / suffix / URL path (query ignored). */
export function guessMimeType(...hints: Array<string | null | undefined>): string | undefined {
  for (const h of hints) {
    if (!h) continue;
    const path = h.split("?")[0].split("#")[0];
    const ext = path.includes(".") ? path.split(".").pop()!.toLowerCase() : path.toLowerCase();
    if (MIME_BY_EXT[ext]) return MIME_BY_EXT[ext];
  }
  return undefined;
}
